import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Window from '../dialog/Window'
import FormWrapper from './Wrapper'
import Render from './Render'


const useStyles = makeStyles(theme => ({
  content: {
    padding: theme.spacing(1),
  }
}))

const FormDialog = ({
  schema,
  size = "md",
  handlers = {},
  initialValues,
  validationSchema,
  error,
  loading,
  onSubmit,
  onCancel,
  ...windowProps
}) => {
  const classes = useStyles()
  return (
    <FormWrapper
      schema={ schema }
      initialValues={ initialValues }
      validationSchema={ validationSchema }
      handlers={ handlers }
      onSubmit={ onSubmit }
    >
      {
        ({
          isValid,
          values,
          errors,
          showErrors,
          touched,
          onSubmit,
        }) => {
          return (
            <Window
              open
              size={ size }
              loading={ loading }
              disabled={ isValid ? false : true }
              onSubmit={ onSubmit }
              onCancel={ onCancel }
              { ...windowProps }
            >
              <div className={ classes.content }>
                <Render
                  fullHeight
                  schema={ schema }
                  handlers={ handlers }
                  error={ error }
                  isValid={ isValid }
                  values={ values }
                  errors={ errors }
                  touched={ touched }
                  showErrors={ showErrors }
                  onSubmit={ onSubmit }
                />
              </div>
              
            </Window>
          )
        }
      }
    </FormWrapper>
  )
}

export default FormDialog